// Membership roles
export const ALUMNI_MEMBERSHIP = 'Alumni'
export const ANNUAL_PASS_MEMBERSHIP = 'Portal Pass'
export const ANNUAL_PASS_ALL_LOCATIONS = 'Portal Pass Supremium'
export const SHRIMP_MEMBERSHIP = 'Shrimp'
export const INVESTOR_MEMBERSHIP = 'Investor'
export const COLLABORATING_ARTIST_MEMBERSHIP = 'Collaborating Artist'
export const LIFETIME_MEMBERSHIP = 'Lifetime'
